import { Link } from 'react-router-dom';
import { ScanLine, Droplets, ShieldAlert, Wrench, ClipboardCheck } from 'lucide-react';
import { Card, CardBody, CardHeader } from '@/components/ui/Card';

const ACTIONS = [
  {
    to: '/expurgo',
    label: 'Verificar kit por leitura',
    description: 'Conferência rápida com scanner e alerta de divergência.',
    icon: ScanLine,
  },
  {
    to: '/lavagem',
    label: 'Enviar para lavagem',
    description: 'Validação de compatibilidade antes do ciclo.',
    icon: Droplets,
  },
  {
    to: '/equipamentos',
    label: 'Verificar equipamento',
    description: 'Checar status e bloqueios críticos do equipamento.',
    icon: Wrench,
  },
  {
    to: '/quarentena',
    label: 'Mover para quarentena',
    description: 'Isolar item/kit com suspeita de não conformidade.',
    icon: ShieldAlert,
  },
  {
    to: '/auditoria',
    label: 'Registrar ocorrência',
    description: 'Abrir registro para rastreabilidade imediata.',
    icon: ClipboardCheck,
  },
];

export function SalaSujaPage() {
  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">Sala suja · modo simplificado</h1>
        <p className="text-sm text-neutral-500">
          Interface com botões grandes para operação com luvas e menor número de toques.
        </p>
      </header>

      <Card>
        <CardHeader title="Ações rápidas" subtitle="Selecione uma operação para continuar" />
        <CardBody>
          <div className="grid gap-3 sm:grid-cols-2">
            {ACTIONS.map((action) => {
              const Icon = action.icon;
              return (
                <Link
                  key={action.to}
                  to={action.to}
                  className="ict-focus-ring group rounded border border-neutral-300 bg-neutral-0 p-4 hover:border-brand-400 hover:bg-brand-50 dark:border-neutral-700 dark:bg-neutral-800 dark:hover:border-brand-600 dark:hover:bg-brand-900/20"
                >
                  <div className="mb-3 flex h-12 w-12 items-center justify-center rounded bg-brand-100 text-brand-700 group-hover:bg-brand-200 dark:bg-brand-900/40 dark:text-brand-300">
                    <Icon size={26} strokeWidth={1.75} />
                  </div>
                  <div className="text-base font-semibold text-neutral-900 dark:text-neutral-100">{action.label}</div>
                  <div className="mt-1 text-sm text-neutral-600 dark:text-neutral-300">{action.description}</div>
                </Link>
              );
            })}
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
